import { defineStore } from 'pinia'

enum ServiceNames {
  gmail = 'gmail',
  facebook = 'facebook'
}
interface GoatDetails {
  avatar?: string
  serviceToken?: string
  serviceName?: `${ServiceNames}` | string
  password_set?: number
}

const useGoatStore = defineStore('storeGoat', () => {
  const goatDetails = ref<GoatDetails>({})

  const getGoatDetails = computed(() => goatDetails.value)

  function updateGoatDetails(goatDetailsData: GoatDetails) {
    goatDetails.value = goatDetailsData
  }
  function clearGoatData() {
    goatDetails.value = {}
  }

  return {
    updateGoatDetails,
    clearGoatData,
    getGoatDetails
  }
})

export { ServiceNames, useGoatStore }
